
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 477.867 477.867","height":"14","width":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M426.667 68.267H51.2c-28.277 0-51.2 22.923-51.2 51.2V358.4c0 28.277 22.923 51.2 51.2 51.2h375.467c28.277 0 51.2-22.923 51.2-51.2V119.467c0-28.277-22.923-51.2-51.2-51.2zm17.066 197.734l-107.4-107.4c-6.664-6.663-17.468-6.663-24.132 0L170.667 300.134l-56.201-56.201c-6.664-6.663-17.468-6.663-24.132 0l-56.201 56.201V119.467c0-9.426 7.641-17.067 17.067-17.067h375.467c9.426 0 17.067 7.641 17.067 17.067v146.534z"}}),_c('circle',{attrs:{"cx":"153.6","cy":"187.733","r":"51.2"}})])
          )
        }
      }
    